export default __webpack_public_path__ + "static/media/tinydao.554981c2.jpeg";